/**
 * @fileoverview Input/output schemas for world-set-snapshotter-v3.
 *
 * This agent updates a world set's state after a chapter has been written.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldSetAttributesV3Schema, WorldSetSnapshotV3Schema } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  worldSet: z.object({
    id: z.string(),
    name: z.string(),
    type: z.literal('set'),
    element: z.enum(['interior', 'exterior']),
    initialDescription: z.string().optional(),
  }).describe('The world set being snapshotted.'),
  previousSnapshot: WorldSetSnapshotV3Schema.optional().describe('The set state before this chapter.'),
  chapterContent: z.string().describe('The full content of the chapter to analyze.'),
  chapterNumber: z.number().describe('The chapter number for snapshot metadata.'),
});

export type Input = z.infer<typeof InputSchema>;

export const OutputSchema = WorldSetAttributesV3Schema.extend({
  notPresentInChapter: z.boolean().optional().describe('True if the set was not mentioned or relevant in this chapter.'),
});

export type Output = z.infer<typeof OutputSchema>;
